// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDateTime,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate & {
  item: $Model<'RegionSeason'> | $ModelUpsertParams<'RegionSeason'>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const RegionSeasonFieldsView = function ({
  item,
  main,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputDateTime
            label={t('Start date')}
            labelOpenCalendar={t('Open calendar')}
            name={'StartDate'}
            required
            timezone={main.timezone}
            value={item.StartDate}
          />
        </Col>
        <Col>
          <InputDateTime
            label={t('End date')}
            labelOpenCalendar={t('Open calendar')}
            name={'EndDate'}
            required
            timezone={main.timezone}
            value={item.EndDate}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Region')}
            name={'RegionId'}
            required
            type={'select'}
            value={item.RegionId}
          >
            {_.map(
              main.regions,
              (i) => (
                <option
                  key={i.id}
                  value={i.id}
                >
                  {i.Name}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
    </>
  );
};

export default RegionSeasonFieldsView;
